import classNames from 'classnames'
import React from 'react'

import styles from './chat-input-shell.module.scss'

export interface ChatInputShellToolbarProps {
  children: React.ReactNode
  className?: string
}

export function ChatInputShellToolbar({ children, className }: ChatInputShellToolbarProps) {
  return <div className={classNames(styles.toolbar, className)}>{children}</div>
}
